import React, { useState, useEffect, useRef } from 'react';
import './InputDialog.css';

const InputDialog = ({ message, placeholder, onConfirm, onCancel }) => {
  const [inputValue, setInputValue] = useState('');
  const dialogRef = useRef(null);
  const inputRef = useRef(null);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleConfirmClick = (event) => {
    event.stopPropagation();
    if (inputValue.trim() !== '') {
      onConfirm(inputValue.trim());
    }
  };

  const handleCancelClick = (event) => {
    event.stopPropagation();
    onCancel();
  };

  // Fermer le InputDialog si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dialogRef.current && !dialogRef.current.contains(event.target)) {
        onCancel();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        handleConfirmClick(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onCancel, inputValue]);

  // Focus sur l'input lorsque le composant s'ouvre
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className="input-dialog-overlay" id="input-dialog-overlay">
      <div className="input-dialog" ref={dialogRef}>
        <p>{message}</p>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}  // Utilisation du placeholder dynamique
          ref={inputRef}
        />
        <div className="input-dialog-buttons">
          <button onClick={handleConfirmClick} className="confirm-dialog-button confirm">
            Valider
          </button>
          <button onClick={handleCancelClick} className="confirm-dialog-button cancel">
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputDialog;
